import { FC } from 'react';

import { useListingLayoutIsShortSelector } from 'shared/store/clientSide/slices/listingLayout';
import { useGetClustersQuery } from 'shared/store/serverSide/commercial-listing-map/desktop/v2/map/get-clusters/query';

import { MapNotifications } from './MapNotifications';

export const MapNotificationsContainer: FC = () => {
  const { isError: isGetClustersError, data: getClustersData, isFetching, isSuccess } = useGetClustersQuery();
  const isShortListing = useListingLayoutIsShortSelector();

  if (!isShortListing || isFetching) {
    return null;
  }

  if (isGetClustersError) {
    return <MapNotifications notificationText="Ошибка загрузки" />;
  }

  if (!getClustersData?.clusters.length && isSuccess) {
    return <MapNotifications notificationText="В данной области ничего не найдено" />;
  }

  return null;
};
